import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";

/* eslint-disable camelcase */
import { LoadData, SaveData as _SaveData, DeleteOne, LoadListFields, DeleteAllParams as _DeleteAllParams } from '@/api/ListParam';
import { mapGetters } from 'vuex';
import WEditor from '@/components/WEditor';
export default {
  name: 'SeniorSetting',
  props: {
    data: {
      type: Array
    }
  },
  components: {
    WEditor: WEditor
  },
  data: function data() {
    return {
      seniorDrawer: false,
      formData: {
        Page: 1,
        Limit: 999
      },
      mainTable: [],
      total: 0,
      loading: false,
      // 操作类型
      actionList: [{
        value: 1,
        label: '等于(=)'
      }, {
        value: 2,
        label: '大于(>)'
      }, {
        value: 3,
        label: '大于等于(>=)'
      }, {
        value: 4,
        label: '小于(<)'
      }, {
        value: 5,
        label: '小于等于(<=)'
      }, {
        value: 6,
        label: '模糊搜索(like)'
      }, {
        value: 7,
        label: '不等于(!=)'
      }, {
        value: 8,
        label: '值为空(null)'
      }, {
        value: 9,
        label: '值不为空(!null)'
      }],
      // 参数类型
      parameterList: [{
        value: 1,
        label: '文本框'
      }, {
        value: 2,
        label: '下拉选择框'
      }, {
        value: 3,
        label: '数字'
      }, {
        value: 4,
        label: '日期'
      }],
      validRules: {
        PARAM_NAME: [{
          required: true,
          message: '请输入字段(参数名)'
        }],
        PARAM_CAPTION: [{
          required: true,
          message: '请输入参数标题'
        }],
        FIELD_NAME: [{
          required: true,
          message: '请输入原始字段'
        }]
      },
      prefix: '',
      // 添加前缀
      SQL_Content: '',
      DtlSQL_Content: '',
      rowid: '',
      dialogFormVisible: false,
      DtldialogFormVisible: false
    };
  },
  computed: _objectSpread({}, mapGetters(['userinfo'])),
  methods: {
    filterParamNameMethod: function filterParamNameMethod(_ref) {
      var value = _ref.value,
          row = _ref.row,
          column = _ref.column;
      var filterData = column.filters[0].data;
      return row.PARAM_NAME.indexOf(filterData) > -1;
    },
    filterFieldNameMethod: function filterFieldNameMethod(_ref2) {
      var value = _ref2.value,
          row = _ref2.row,
          column = _ref2.column;
      var filterData = column.filters[0].data;
      return row.FIELD_NAME.indexOf(filterData) > -1;
    },
    filterParamCaptionMethod: function filterParamCaptionMethod(_ref3) {
      var value = _ref3.value,
          row = _ref3.row,
          column = _ref3.column;
      var filterData = column.filters[0].data;
      return row.PARAM_CAPTION.indexOf(filterData) > -1;
    },
    // 同步信息
    seniorSettingSync: function seniorSettingSync() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res, data, column, indexSearch;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _context.next = 3;
                return LoadListFields({
                  USER_NAME: _this.userinfo.USER_NAME
                }).catch(function (_) {
                  _this.loading = false;
                });

              case 3:
                res = _context.sent;
                _this.loading = false;

                if (res.Result) {
                  data = res.Result || [];
                  column = [];

                  _this.mainTable.forEach(function (item) {
                    column.push(item.PARAM_NAME);
                  });

                  console.log(column);
                  indexSearch = [];
                  data.map(function (item) {
                    console.log(item.FIELD_NAME, column.indexOf(item.FIELD_NAME));
                    indexSearch.push(column.indexOf(item.FIELD_NAME));
                  });
                  indexSearch.forEach(function (item, index) {
                    if (item !== -1) {
                      console.log(_this.mainTable[item].PARAM_NAME, data[index].FIELD_CAPTION);
                      _this.mainTable[item].PARAM_CAPTION = data[index].FIELD_CAPTION;
                    }
                  }); // indexSearch.map((item,index)=>{
                  //   if(index!=-1){
                  //     this.mainTable=
                  //   }
                  // })
                  // console.log(data, indexSearch)
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 保存
    seniorSettingSave: function seniorSettingSave() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var $table, errMap, _$table, _$table$getTableData, fullData;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                $table = _this2.$refs.xTable;
                _context2.next = 3;
                return $table.validate(true).catch(function (errMap) {
                  return errMap;
                });

              case 3:
                errMap = _context2.sent;

                if (errMap) {
                  _context2.next = 10;
                  break;
                }

                _$table = _this2.$refs.xTable;
                _$table$getTableData = _$table.getTableData(), fullData = _$table$getTableData.fullData;

                if (!(fullData && fullData.length <= 0)) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt("return");

              case 9:
                _this2.SaveData(fullData);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    SaveData: function SaveData(data) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var loading, res, $table;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                loading = _this3.$loading({
                  lock: true,
                  text: 'Loading',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
                });
                _context3.next = 3;
                return _SaveData(data).catch(function (_) {
                  loading.close();
                });

              case 3:
                res = _context3.sent;
                loading.close();

                if (res.Result) {
                  $table = _this3.$refs.xTable;
                  $table.loadData();
                  _this3.seniorDrawer = false;

                  _this3.$emit('SeniorSetting', $table.data);

                  _this3.$notify({
                    title: '成功',
                    message: '保存成功',
                    type: 'success'
                  });
                } else {
                  _this3.$notify({
                    title: '错误',
                    message: res.ErrorInfo.Message,
                    type: 'warning'
                  });
                }

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 相关联SQL
    Associated_SQL: function Associated_SQL(scope) {
      console.log(scope);
      var REFERENCE_SQL = scope.row.REFERENCE_SQL;
      this.rowid = scope.rowid;

      if (!REFERENCE_SQL) {
        this.SQL_Content = '';
      } else {
        this.SQL_Content = REFERENCE_SQL;
      }

      this.dialogFormVisible = true;
    },
    // 子查询SQL
    Associated_DtlSQL: function Associated_DtlSQL(scope) {
      var SUB_SQL = scope.row.SUB_SQL;
      console.log(scope);
      this.rowid = scope.rowid;

      if (!SUB_SQL) {
        this.DtlSQL_Content = '';
      } else {
        this.DtlSQL_Content = SUB_SQL;
      }

      this.DtldialogFormVisible = true;
    },
    submit_but: function submit_but() {
      var _this4 = this;

      console.log('this.rowid', this.rowid);
      var $table = this.$refs.xTable;

      var _$table$getTableData2 = $table.getTableData(),
          fullData = _$table$getTableData2.fullData;

      fullData.map(function (item) {
        var key = item._XID || item._X_ROW_KEY;

        if (key === _this4.rowid) {
          item.REFERENCE_SQL = _this4.SQL_Content;
        }
      });
      console.log('fullData', fullData);
      this.dialogFormVisible = false;
      this.SQL_Content = '';
    },
    // 子SQL保存
    Dtlsubmit_but: function Dtlsubmit_but() {
      var _this5 = this;

      var $table = this.$refs.xTable;

      var _$table$getTableData3 = $table.getTableData(),
          fullData = _$table$getTableData3.fullData;

      fullData.map(function (item) {
        var key = item._XID || item._X_ROW_KEY;

        if (key === _this5.rowid) {
          item.SUB_SQL = _this5.DtlSQL_Content;
        }
      });
      this.DtldialogFormVisible = false;
      this.DtlSQL_Content = '';
    },
    // 删除所有
    seniorSettingDeleteAll: function seniorSettingDeleteAll() {
      var _this6 = this;

      var $table = this.$refs.xTable;

      var _$table$getTableData4 = $table.getTableData(),
          fullData = _$table$getTableData4.fullData;

      if (fullData && fullData.length <= 0) return;
      this.$confirm('此操作将全部删除配置项, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var tempData;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                tempData = [];
                fullData && fullData.map(function (item) {
                  if (!item.LIST_ROUTE) {
                    _this6.$refs.xTable.remove(item);
                  } else {
                    tempData.push(item);
                  }
                });

                if (!(tempData && tempData.length <= 0)) {
                  _context4.next = 8;
                  break;
                }

                _this6.seniorDrawer = false;

                _this6.$emit('SeniorSetting', $table.data);

                return _context4.abrupt("return", _this6.$notify({
                  title: '成功',
                  message: '删除成功',
                  type: 'success'
                }));

              case 8:
                _this6.DeleteAllParams(tempData[0]);

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))).catch(function () {});
    },
    // 全部删除
    DeleteAllParams: function DeleteAllParams(data) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res, $table;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _DeleteAllParams(data);

              case 2:
                res = _context5.sent;

                if (res.Result) {
                  _this7.seniorDrawer = false;
                  $table = _this7.$refs.xTable;

                  _this7.$emit('SeniorSetting', $table.data);

                  _this7.$notify({
                    title: '成功',
                    message: '删除成功',
                    type: 'success'
                  });
                }

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    // 添加前缀
    handlePrefix: function handlePrefix() {
      var _this8 = this;

      var $table = this.$refs.xTable;

      var _$table$getTableData5 = $table.getTableData(),
          fullData = _$table$getTableData5.fullData;

      fullData.map(function (item) {
        item.FIELD_NAME = _this8.prefix + item.PARAM_NAME;
      });
    },
    // 添加字段
    seniorSettingField: function seniorSettingField() {
      var $table = this.$refs.xTable;

      var _$table$getTableData6 = $table.getTableData(),
          fullData = _$table$getTableData6.fullData;

      var field = [];
      var title = [];
      var collectColumn = this.$parent.$refs.xTable.collectColumn;
      collectColumn && collectColumn.map(function (item) {
        if (item.property) {
          field.push(item.property);
          title.push(item.title);
        }
      });

      if (fullData.length <= 0) {
        field.forEach(function (item, index) {
          var record = {
            ORD_IDX: index + 1,
            PARAM_NAME: item,
            PARAM_CAPTION: title[index],
            FIELD_NAME: item,
            ACTION_TYPE: 6,
            PARAM_VALUE: '',
            DATA_TYPE: 1,
            REFERENCE_SQL: '',
            SUB_SQL: '',
            IS_PAGING: 'N',
            REMARK: ''
          };
          $table.insertAt(record);
        });
      } else {
        var maxIndex = Math.max.apply(Math, fullData.length <= 0 ? [0] : fullData.map(function (o) {
          return o.ORD_IDX;
        })) + 1;
        var column = [];
        fullData.forEach(function (item) {
          column.push(item.PARAM_NAME);
        });
        var indexSearch = [];
        field.map(function (item) {
          indexSearch.push(column.indexOf(item));
        });
        indexSearch.forEach(function (item, index) {
          if (item === -1) {
            var record = {
              ORD_IDX: maxIndex++,
              PARAM_NAME: field[index],
              PARAM_CAPTION: title[index],
              FIELD_NAME: field[index],
              ACTION_TYPE: 6,
              PARAM_VALUE: '',
              DATA_TYPE: 1,
              REFERENCE_SQL: '',
              SUB_SQL: '',
              IS_PAGING: 'N',
              REMARK: ''
            };
            $table.insertAt(record);
          }
        });
      }

      this.$refs.xTable.sort('ORD_IDX', 'asc');
    },
    // 点击新增按钮
    seniorSettingAdd: function seniorSettingAdd() {
      var $table = this.$refs.xTable;

      var _$table$getTableData7 = $table.getTableData(),
          fullData = _$table$getTableData7.fullData;

      var maxIndex = Math.max.apply(Math, fullData.length <= 0 ? [0] : fullData.map(function (o) {
        return o.ORD_IDX;
      })) + 1;
      var record = {
        ORD_IDX: maxIndex,
        PARAM_NAME: '',
        PARAM_CAPTION: '',
        FIELD_NAME: '',
        ACTION_TYPE: 6,
        PARAM_VALUE: '',
        DATA_TYPE: 1,
        REFERENCE_SQL: '',
        SUB_SQL: '',
        IS_PAGING: 'N',
        REMARK: ''
      };
      $table.insertAt(record);
    },
    // 加载
    handleSearchTableLoad: function handleSearchTableLoad() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this9.seniorDrawer = true;
                _this9.loading = true;
                _context6.next = 4;
                return LoadData(_this9.formData).catch(function (_) {
                  _this9.loading = false;
                });

              case 4:
                res = _context6.sent;
                _this9.loading = false;
                console.log('res', res);

                if (res.data) {
                  _this9.mainTable = res.data || [];
                  _this9.total = res.TotalCount;
                }

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    handleSizeChange: function handleSizeChange(Limit) {
      this.formData.Limit = Limit;
      this.handleSearchTableLoad();
    },
    handleCurrentChange: function handleCurrentChange(Page) {
      this.formData.Page = Page;
      this.handleSearchTableLoad();
    },
    removeClick: function removeClick(row) {
      var _this10 = this;

      console.log(row);

      if (!row.LIST_ROUTE) {
        this.$refs.xTable.remove(row);
        var num = 1;
        this.$refs.xTable.getTableData().tableData.map(function (item) {
          item.ORD_IDX = num;
          num++;
        });
      } else {
        this.$confirm('此操作将删除该数据配置项, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
          var res, num;
          return regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  _context7.next = 2;
                  return DeleteOne(row);

                case 2:
                  res = _context7.sent;

                  if (res.Result) {
                    _this10.$refs.xTable.remove(row);

                    num = 1;

                    _this10.$refs.xTable.getTableData().tableData.map(function (item) {
                      item.ORD_IDX = num;
                      num++;
                    });

                    _this10.$notify({
                      title: '成功',
                      message: '删除成功',
                      type: 'success'
                    });
                  }

                case 4:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7);
        }))).catch(function () {});
      }
    },
    searchClick: function searchClick() {},
    isCheckColse: function isCheckColse() {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var $table, errMap;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                $table = _this11.$refs.xTable;
                _context8.next = 3;
                return $table.validate(true).catch(function (errMap) {
                  return errMap;
                });

              case 3:
                errMap = _context8.sent;

                if (!errMap) {
                  _this11.$confirm('检测到高级配置存在未保存项, 是否保存?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                  }).then(function () {
                    _this11.seniorSettingSave();
                  }).catch(function () {
                    _this11.seniorDrawer = false;
                  });
                } else {
                  _this11.seniorDrawer = false;
                }

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    handleColseDrawer: function handleColseDrawer() {
      var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var $table = this.$refs.xTable;

      var _$table$getRecordset = $table.getRecordset(),
          insertRecords = _$table$getRecordset.insertRecords,
          updateRecords = _$table$getRecordset.updateRecords,
          removeRecords = _$table$getRecordset.removeRecords;

      if (insertRecords.length > 0 || updateRecords.length > 0 || removeRecords.length > 0) {
        this.isCheckColse();
      } else {
        this.seniorDrawer = flag;
      }
    }
  }
};